module.exports = __webpack_public_path__ + "img/wiphala.cb755e3f.svg";